import { queryOptions, useQuery } from '@tanstack/react-query';

import { serviceQuestionKeys } from './query-key-factory';

import { QueryConfig } from '@/lib/react-query';
import { supabase } from '@/lib/supabase-client';
import { logger } from '@/logger';

export type ServiceQuestion = Awaited<ReturnType<typeof getQuestion>>;

export const getQuestion = async ({ qid }: { qid: string }) => {
  const { data, error } = await supabase
    .from('questions')
    .select(
      `id,
      text,
      type,
      technician_id,
      created_at,
      choices:question_choices(*),
      sq:service_questions(*)`,
    )
    .eq('id', qid)
    .single();

  if (error) {
    logger.error('Failed to get question:', {
      errorMessage: error,
      qid,
    });
    throw error;
  }

  return data;
};

export const getQuestionQueryOptions = (qid: string) => {
  return queryOptions({
    queryKey: serviceQuestionKeys.detail(qid),
    queryFn: () => getQuestion({ qid }),
  });
};

type UseQuestionOptions = {
  qid: string;
  queryConfig?: QueryConfig<typeof getQuestionQueryOptions>;
};

export const useQuestion = ({ qid, queryConfig }: UseQuestionOptions) => {
  return useQuery({
    ...getQuestionQueryOptions(qid),
    ...queryConfig,
  });
};
